import {
  TAX_STATUS,
  TAX_STATUS_LABEL,
  LOAN_TERM,
  LOAN_TERM_LABEL,
} from '../../../../lib/rentvsbuy-constants';

export const LOAN_TERM_30_YEAR = {
  label: LOAN_TERM_LABEL.THIRTY,
  value: LOAN_TERM.THIRTY,
};

export const LOAN_TERM_15_YEAR = {
  label: LOAN_TERM_LABEL.FIFTEEN,
  value: LOAN_TERM.FIFTEEN,
};

export const loanTerms = [LOAN_TERM_30_YEAR, LOAN_TERM_15_YEAR];

export const INDIVIDUAL = {
  label: TAX_STATUS_LABEL.INDIVIDUAL,
  value: TAX_STATUS.INDIVIDUAL,
};
export const JOINT = {
  label: TAX_STATUS_LABEL.JOINT,
  value: TAX_STATUS.JOINT,
};

export const TAX_FILING_STATUS_OPTIONS = [INDIVIDUAL, JOINT];
